export const SET_MAIN_GRAPH_BLOCK_WIDTH = 'SET_MAIN_GRAPH_BLOCK_WIDTH'
export const SET_MAIN_GRAPH_BLOCK_HEIGHT = 'SET_MAIN_GRAPH_BLOCK_HEIGHT'
export const SET_IS_LEFT_NAV_OPEN = 'SET_IS_LEFT_NAV_OPEN'
export const SET_IS_RIGHT_NAV_OPEN = 'SET_IS_RIGHT_NAV_OPEN'
export const SET_IS_BOTTOM_NAV_OPEN = 'SET_IS_BOTTOM_NAV_OPEN'
